import React from "react";

const Loadding = () => {
  return (
    <>
      <div className="spinner-border spinner-border-sm mt-5" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>{" "}
      Loading...
    </>
  );
};

export default Loadding;
